// @flow
/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['active'] }] */

import * as React from 'react';
import { connect } from 'react-redux';

import { localize } from '@ta/common.i18n';
import Popover from '@ta/overlays.popover';
import type { ViewportCategory } from '@ta/common.state';
import { Icon } from '@ta/styleguide.icon';
import { trackClick } from '@ta/common.tracking';
import { InteractionLogger } from '@ta/tracking.interactions';

import disabledSocialStyles from './DisabledSocialAction.less';
import socialStyles from './SocialAction.less';

/**
 * Display a social action w/ messaging - disabled in beta
 */

type ExternalProps = {|
  actionType: 'Save' | 'Share',
|};

type Props = {|
  ...ExternalProps,
  viewportCategory: ViewportCategory,
|};

type State = {
  tracked: boolean,
};

class DisabledSocialAction extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { tracked: false };
  }

  setTracking = (e: SyntheticEvent<*>, text: string) => {
    if (!this.state.tracked) {
      trackClick(e, { module: `${text}Action_Disabled`, action: 'CLICK' });
      this.setState({ tracked: true });
    }
  };

  render() {
    let icon;
    let text;
    let interactionType;

    switch (this.props.actionType) {
      case 'Save':
        icon = 'bookmark-fill';
        text = localize('social_Save');
        interactionType = 'save';
        break;
      case 'Share':
        icon = 'repost-fill';
        text = localize('link_share_share');
        interactionType = 'share';
        break;
      default:
      // Do nothing
    }

    const mobileOnly = this.props.viewportCategory === 'MOBILE';
    const alignEdge = !mobileOnly ? 'left' : 'right';
    const shiftX = !mobileOnly ? -28 : 12;
    const shiftArrow = !mobileOnly ? 12 : 8;
    return (
      <Popover
        above
        alignEdge={alignEdge}
        shiftX={shiftX}
        shiftY={-8}
        shiftArrow={shiftArrow}
        arrowType="small"
        contents={() => (
          <span className={disabledSocialStyles.body_text}>{localize('social_Coming_soon')}</span>
        )} // Sorry, this feature is not available yet. Coming soon!
        local
      >
        {(target, open) => (
          <InteractionLogger>
            {logInteraction => (
              <span
                className={socialStyles.social_action}
                ref={target}
                onClick={e => {
                  logInteraction(e, interactionType);
                  open();
                  this.setTracking(e, text);
                }}
              >
                <Icon name={icon} className={socialStyles.icon} />
                <span className={`ui_link ${socialStyles.text} socialCTA`}>{text}</span>
              </span>
            )}
          </InteractionLogger>
        )}
      </Popover>
    );
  }
}

export default connect<Props, ExternalProps, _, _, _, _>(redux => ({
  viewportCategory: redux.meta.device.viewportCategory,
}))(DisabledSocialAction);
